import { render, staticRenderFns } from "./DisciplineTable.vue?vue&type=template&id=15d3768f&scoped=true&"
import script from "./DisciplineTable.vue?vue&type=script&lang=js&"
export * from "./DisciplineTable.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineTable.vue?vue&type=style&index=0&id=15d3768f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3768f",
  null
  
)

export default component.exports